<div class="parallax">
    <div class="title">
        <h1>
            <strong>Nos Produits</strong>
        </h1>
    </div>
    <div class="container">
        <div *ngIf="loading" id="loadingPage"></div>
        <div class="families" *ngIf="!loading">
            <a routerLink="/carte/famille/{{family.slug}}" *ngFor="let family of families"
                class="families__item">
                <div class="families__item--family"> {{family.label|uppercase}}</div>
                <div class="families__item--img">
                    <div class="loadingAvatar" *ngIf="!loadAvatar"></div>
                    <img [class.v-hidden]="!loadAvatar" appLazyLoad (lodedImage)="loadAvatar=true" [src]="family.avatar|absolutePath:'families'"
                        title="Livraison {{city}} {{family.label}}" alt="Livraison {{city}} {{family.label}}">
                </div>
            </a>
        </div>
    </div>
</div>